/*Filter returns true if error message should be filtered*/
const sentryFilter = (event, hint) => {
  // aws amplify throws this when the user navigates before the sign-up components loads

  try {
    if (hint) {
      // we don't care about network connection errors
      const error = hint.originalException;
      let errorMessage;
      if (typeof error === "string") {
        errorMessage = error;
      } else if (error instanceof Error) {
        errorMessage = error.message;
      }

      switch (errorMessage) {
        case "The user is not authenticated":
        case "Cstr is undefined":
        case "Cannot read properties of undefined (reading 'isProxied')":
          console.log("filtering error on message:", errorMessage);
          return true;
        default:
          break;
      }
    }

    if (event.breadcrumbs && event.breadcrumbs.length > 0) {
      // bread crumb messages
      const breadCrumbMessages = event.breadcrumbs.filter(e => e.category === "console" && e.message).map(e => e.message);

      for (let i = 0; i < breadCrumbMessages.length; i++) {
        const breadCrumbMessage = breadCrumbMessages[i];
        // aws amplify throws this when the user navigates before the sign-up components loads
        if (breadCrumbMessage.startsWith("ChunkLoadError") || breadCrumbMessage.includes("Loading chunk")) {
          console.log("filtering error on breadcrumb message:", breadCrumbMessage);
          return true;
        }
      }
    }
  } catch (e) {
    console.log("could not run awsAmplifyFilter", e);
  }
};

export default sentryFilter;
